/* EA-Onlineshop · Ladeplatz-Finder + sanfte Einblendungen */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initReveal() {
    var items = document.querySelectorAll('.bx-rise:not([data-bx-reveal-ready])');
    if (!items.length) return;
    items.forEach(function (el) { el.dataset.bxRevealReady = 'true'; });
    if (reduce.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in', 'is-done'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.add('is-in');
        io.unobserve(el);
        el.addEventListener('transitionend', function onEnd() {
          el.classList.add('is-done');
          el.removeEventListener('transitionend', onEnd);
        });
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  function initFinder() {
    var root = document.querySelector('[data-bx-finder]');
    if (!root || root.dataset.bxFinderReady === 'true') return;
    root.dataset.bxFinderReady = 'true';

    var data;
    var raw = root.querySelector('[data-bx-results]');
    if (!raw) return;
    try { data = JSON.parse(raw.textContent); } catch (err) { return; }
    if (!data || !data.length) return;

    var card = root.querySelector('[data-bx-card]');
    var elPic = root.querySelector('[data-bx-image]');
    var elTitle = root.querySelector('[data-bx-title]');
    var elChips = root.querySelector('[data-bx-chips]');
    var elSw = root.querySelector('[data-bx-swatches]');
    var elPrice = root.querySelector('[data-bx-price]');
    var elLink = root.querySelector('[data-bx-link]');
    var elLive = root.querySelector('[data-bx-live]');
    if (!card || !elTitle || !elLink) return;

    var state = {
      place: root.dataset.bxDefaultPlace || 'mobil',
      setup: root.dataset.bxDefaultSetup || 'phone'
    };

    function pick() {
      for (var i = 0; i < data.length; i++) {
        if (data[i].place === state.place && data[i].setup === state.setup) return data[i];
      }
      return data[0];
    }

    function paint(r, animate) {
      function write() {
        if (elPic && r.image) {
          elPic.removeAttribute('srcset');
          elPic.removeAttribute('sizes');
          elPic.src = r.image;
          elPic.alt = r.title || '';
        }
        elTitle.textContent = r.title || '';
        if (elPrice) elPrice.textContent = r.price || '';
        elLink.href = r.url || '#';
        if (elChips) {
          elChips.innerHTML = '';
          (r.chips || []).forEach(function (c) {
            var s = document.createElement('span');
            s.textContent = c;
            elChips.appendChild(s);
          });
        }
        if (elSw) {
          elSw.innerHTML = '';
          (r.swatches || []).forEach(function (c) {
            var i = document.createElement('i');
            i.style.background = c.color;
            i.title = c.name;
            elSw.appendChild(i);
          });
        }
        if (elLive) elLive.textContent = 'Dein Ergebnis: ' + (r.title || '') + ', ' + (r.price || '');
      }

      if (!animate || reduce.matches) { write(); return; }
      card.classList.add('is-swapping');
      window.setTimeout(function () {
        write();
        card.classList.remove('is-swapping');
      }, 180);
    }

    root.querySelectorAll('[data-bx-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.dataset.bxGroup;
        var value = btn.dataset.bxOpt;
        if (state[group] === value) return;
        state[group] = value;
        root.querySelectorAll('[data-bx-group="' + group + '"]').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === btn));
        });
        paint(pick(), true);
      });
    });

    paint(pick(), false);
  }

  function boot() { initReveal(); initFinder(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
